<div class="checkbox" [ngClass]="getLevelClass()">
  <div [ngClass]="{ 'checkbox--readonly': isReadonly }">
    <input
      type="checkbox"
      class="checkbox__input"
      [readonly]="isReadonly"
      [(ngModel)]="inputText"
      (change)="trigger()"
      id="{{ componentId }}"
      [disabled]="isServer || isDisabled"
    />
    <basic-label
      class="label-basic"
      [overrideDisplayText]="labelText"
      [componentId]="componentId"
      [inputClass]="'checkbox__label checkbox__label--large checkbox__label--dark'"
      [noIndent]="true"
    ></basic-label>
  </div>
</div>
